/**
* Copyright Aquera Inc 2023
*
* This source code is licensed under the BSD-3-Clause license found in the
* LICENSE file in the root directory of this source tree.
*/

import {css} from 'lit';

/**
 * SideBarLogo CSS
 */
export const styles = css`
:host {
  justify-content: center;
  height: 100%;
  flex: 0;
}

.logo {
  max-height: 32px;
  object-fit: contain;
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.logo.expanded {
  display: block;
}

.logo.collapsed {
  display: none;
}

:host([collapsed]) .logo.expanded {
  display: none;
}

:host([collapsed]) .logo.collapsed {
  display: block;
}

:host(:not([collapsed])) .logo.expanded {
  display: block;
}

:host(:not([collapsed])) .logo.collapsed {
  display: none;
}
`;


export default [styles];